import { useEffect, useState } from "react";
import { Form, Button, Container, Row, Col, InputGroup } from "react-bootstrap";
import { Link, navigate, useLocation } from "@reach/router";
import qs from "qs";

import "./login.scss";
import { useAppContext } from "../libs/contextLib";
import Api from "../components/Api";
import { PRIVACY_POLICY, TERMS_OF_USE, COMMON_ERROR } from "constants/common";
import { NAME_FORM_LABEL } from "constants/login";

export default function Login() {
  const location = useLocation();
  const {
    authenticatedUser,
    authenticateUser,
    updateErrorMessage,
  } = useAppContext();
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [requestedOtp, setRequestedOtp] = useState();
  const [submittedOtp, setSubmittedOtp] = useState();

  function validatePhone() {
    return phone.length === 10;
  }

  function validateCode() {
    return otp.length === 6;
  }

  function validateName() {
    return firstName.length > 2 && lastName.length > 2;
  }

  function getOtp(event) {
    event.preventDefault();
    Api()
      .post("/students/otp", { phone: phone })
      .then(
        (response) => {
          if (response.status === 200) {
            setRequestedOtp(true);
          }
        },
        (onerror) => {
          updateErrorMessage(COMMON_ERROR);
        }
      );
  }

  useEffect(() => {
    const queryParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    async function navigateFromLogin() {
      await navigate(queryParams.redirect || "/");
    }

    if (authenticatedUser && authenticatedUser.first_name) {
      navigateFromLogin();
    }
  }, [authenticatedUser, authenticateUser.first_name, location.search]);

  function submitOtp(event) {
    event.preventDefault();

    Api()
      .post("/students/login", { phone: phone, code: otp })
      .then(
        (response) => {
          if (response.status === 200) {
            setSubmittedOtp(true);
            if (response.data.first_name) {
              authenticateUser(response.data);
            }
          }
        },
        (onerror) => {
          if (onerror.response.status === 401) {
            updateErrorMessage(onerror.response.data["detail"]);
          } else {
            updateErrorMessage(COMMON_ERROR);
          }
        }
      );
  }

  function changePhoneNumber() {
    setPhone("");
    setRequestedOtp(false);
  }

  function updateName(event) {
    event.preventDefault();
    console.log(firstName);

    Api()
      .patch("students/me", { first_name: firstName, last_name: lastName })
      .then(
        (response) => {
          if (response.status === 200) {
            authenticateUser(response.data);
          }
        },
        (error) => {
          console.log(error);
          updateErrorMessage(COMMON_ERROR);
        }
      );
  }

  return (
    <Container>
      <Row className="justify-content-center">
        {!requestedOtp ? (
          <Col className="login-container get-otp" xs={10} md={6}>
            <Form onSubmit={getOtp}>
              <Form.Group size="lg" controlId="phone">
                <Form.Label>
                  <div className="welcome-header">
                    Login <span className="welcome-header-small">or</span>{" "}
                    Signup
                  </div>
                </Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text id="basic-addon1">+91</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    autoFocus
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Mobile Number"
                  ></Form.Control>
                </InputGroup>
              </Form.Group>
              <div className="mid-links">
                By continuing, I agree to the{" "}
                <Link to={"/tnc"}>{TERMS_OF_USE}</Link> &amp;{" "}
                <Link to={"/privacy-policy"}>{PRIVACY_POLICY}</Link>
              </div>
              <Button
                className="submit-button"
                block
                size="lg"
                type="submit"
                disabled={!validatePhone()}
              >
                CONTINUE
              </Button>
            </Form>
          </Col>
        ) : !submittedOtp ? (
          <Col className="login-container submit-otp" xs={10} md={6}>
            <Form onSubmit={submitOtp}>
              <Form.Group size="lg" controlId="phone">
                <Form.Label>
                  <h5>Verify with OTP</h5>
                  <h6>Sent to {phone}</h6>
                </Form.Label>
                <Form.Control
                  autoFocus
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="OTP"
                />
              </Form.Group>
              <Button
                className="submit-button"
                block
                size="lg"
                type="submit"
                disabled={!validateCode()}
              >
                LOGIN
              </Button>
            </Form>
            <Button
              className="bottom-link"
              variant="link"
              onClick={changePhoneNumber}
            >
              Change phone number?
            </Button>
            <div className="bottom-link">
              Having trouble logging in?
              <span>
                {" "}
                <Link to={"/help-center"}>Get help here.</Link>
              </span>
            </div>
          </Col>
        ) : (
          <Col className="login-container get-name" xs={10} md={6}>
            <Form onSubmit={updateName}>
              <Form.Group size="lg" controlId="name">
                <Form.Label>
                  <div className="welcome-header">{NAME_FORM_LABEL}</div>
                </Form.Label>
                <Row>
                  <Col>
                    <Form.Control
                      autoFocus
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      placeholder="First name"
                    ></Form.Control>
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      placeholder="Last name"
                    ></Form.Control>
                  </Col>
                </Row>
              </Form.Group>
              <Button
                className="submit-button"
                block
                size="lg"
                type="submit"
                disabled={!validateName()}
              >
                CONTINUE
              </Button>
            </Form>
          </Col>
        )}
      </Row>
    </Container>
  );
}
